import React from 'react'
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Icon } from './base/Icon/Icon'

export const FavoriteToggle = ({
  isFavorite,
  onPress,
  iconStyle,
}: {
  isFavorite: boolean
  onPress: () => void
  iconStyle?: StyleProp<ViewStyle>
}) => {
  const styles = useStyleSheet(themedStyle)

  return (
    <TouchableOpacity accessibilityLabel="Toggle favorite" onPress={onPress}>
      <Icon
        name="heart"
        style={[styles.heartIcon, iconStyle, isFavorite && styles.favorite]}
        weight={isFavorite ? 'fill' : 'regular'}
      />
    </TouchableOpacity>
  )
}

const themedStyle = StyleService.create({
  heartIcon: {
    width: 28,
    height: 28,
  },
  favorite: {
    color: 'theme.like',
  },
})
